import React from 'react';
import styles from './WhatWeDoHero.module.css';
import '../styles/theme.css';

/*
  Dark hero band that opens the WHAT WE DO page.
  - serif lede ("A knowledge-for-policy consultancy")
  - 3 paragraph cards (yellow top accent) below
*/
function WhatWeDoHero() {
  return (
    <section className={styles['hero']}>
      <div className={styles['hero-inner']}>
        <h1 className={styles['title']}>
          A <em>knowledge-for-policy</em> institute
        </h1>

        <div className={styles['lead-wrap']}>
          <p className={styles['lead']}>
            We build and lead experienced teams that bring together a unique
            blend of academic knowledge and global policy expertise, with
            comprehensive know-how in{' '}
            <span className={styles['accent']}>
              policy development and evaluation, advanced data analytics, and
              strategic planning.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhatWeDoHero;
